import axios from 'axios';
import qs from 'qs';
import helpers from '../util/helpers';
import * as constants from '../util/constants';

export default {
  init() {},
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // Offers
    const offersWrapper = $('#hotel-offers-wrapper');
    if (offersWrapper.length) {
      // Cancel token source
      let cancelTokenSource = null;

      const handleOffersResults = function(offset = 0) {
        // Cancel previous request if it exists
        if (cancelTokenSource) {
          cancelTokenSource.cancel('New request initiated, cancel previous.');
        }
        cancelTokenSource = axios.CancelToken.source();

        const skeleton = $('#hotel-offers-skeleton');
        const loadMoreButtonWrapper = $('#hotel-offers-load-more-button-wrapper');
        let page = parseInt(offersWrapper.data('page'), 10);
        const perPage = parseInt(offersWrapper.data('per-page'), 10);
        const params = helpers.getParameters();

        if (offset === 0) {
          offersWrapper.html('');
        }
        skeleton.show();
        loadMoreButtonWrapper.hide();

        // Params
        const data = {
          'action': constants.ACTION_GET_HOTEL_OFFERS,
          'type': params['type'] || '',
          'offset': offset,
        };

        // Send request
        axios.post(window.Rydges['ajaxUrl'], qs.stringify(data), {
          cancelToken: cancelTokenSource.token,
        }).then((axiosResponse) => {
          if (200 === axiosResponse.status) {
            const response = axiosResponse.data;

            skeleton.hide();

            if (response.success) {
              const count = response.data['count'];
              const html = response.data['html'];

              if (html.length) {
                if (offset === 0) {
                  offersWrapper.html(html);
                  page = 1;
                  offset = perPage;
                } else {
                  offersWrapper.append(html);

                  // Increment page and offset
                  page += 1;
                  offset += perPage;
                }

                // Update attributes
                offersWrapper.data('page', page).attr('data-page', page);
                offersWrapper.data('offset', offset).attr('data-offset', offset);

                // Update URL
                params['page_number'] = page;
                helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

                // Equal height for elements
                $(document).trigger(constants.EVENT_BALANCE_ELEMENTS);

                if (offset >= count) {
                  loadMoreButtonWrapper.hide();
                } else {
                  loadMoreButtonWrapper.show();
                }
              } else {
                loadMoreButtonWrapper.hide();
              }
            } else {
              loadMoreButtonWrapper.hide();
            }
          }
        }).catch((error) => {
          console.log(error);
        });
      };

      const hotelOffersFilter = $('#hotel-offers-filter');
      if (hotelOffersFilter.length) {
        hotelOffersFilter.on('select2:select', function() {
          const _this = $(this);
          const selectedVal = _this.val();
          const params = helpers.getParameters();

          if (selectedVal !== '') {
            params['type'] = selectedVal;
          } else {
            delete params['type'];
          }

          // Push params to url
          helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

          handleOffersResults();

          $(document).trigger(constants.EVENT_SELECT_FILTER_CHANGED, [selectedVal]);
        });
      }

      const loadMoreButton = $('#hotel-offers-load-more-button');
      if (loadMoreButton.length) {
        loadMoreButton.on('click', function(e) {
          e.preventDefault();

          const offset = parseInt(offersWrapper.data('offset'), 10) || 0;

          handleOffersResults(offset);
        });
      }
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateHotelOffersPage.js